export function showMessage (instance, type, message) {
  instance.$set(instance.message, 'style', type)
  instance.$set(instance.message, 'text', message)
  instance.submitting = false
  setTimeout(() => {
    instance.$set(instance.message, 'style', '')
    instance.$set(instance.message, 'text', '')
  }, 5000)
}



//////////////////
// WEBPACK FOOTER
// ./utils/index.js
// module id = DHvs
// module chunks = 1